module.exports = __webpack_public_path__ + "2d346479d01d48cb5b08cb8dc4571fec.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/perks/houses/leaning-t-owl-er-of-pisa-empty.png
// module id = 324
// module chunks = 0